import { MatchTeamPlayerItem as MatchTeamPlayerItemComponent } from './MatchTeamPlayerItem.component';
import { connector } from './MatchTeamPlayerItem.connector';

export const MatchTeamPlayerItem = connector(MatchTeamPlayerItemComponent);
